import React from "react";
import { NavLink, useLocation } from 'react-router-dom'
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap'
import logo from './assets/HF_Logo_White.png'

const ComHeader = (props) => {
    const currentPath = useLocation();
    const pageOrder = [
        '/', '/PlanSelect', '/Application', '/Completed'
    ];

    const renderNavLinkClass = ({ isActive }, linkPath) => {
        let classes = ['nav-link'];

        if (isActive) {
            classes.push('active');
        } else {
            classes.push('inactive');

            if (linkPath) {
                if (pageOrder.indexOf(linkPath) > pageOrder.indexOf(currentPath.pathname)) {
                    classes.push('disabled');
                }
            }
        }

        return classes.filter(Boolean).join(' ');
    }

    return (
        <header className='main-header bg-primary'>
            <Navbar expand="lg" className="navbar-dark">
                <Container fluid >
                    <Navbar.Brand className='fw-medium'><img src={logo} alt='Health First' width='150' /></Navbar.Brand>
                    <Navbar.Brand className='fw-medium px-3'>HFHP Off Market</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav>
                            <NavLink className={renderNavLinkClass} to="/">Intake</NavLink>
                            <NavLink className={(props) => renderNavLinkClass(props, '/PlanSelect')} to="/PlanSelect">Plan Select</NavLink>
                            <NavLink className={(props) => renderNavLinkClass(props, '/Application')} to="/Application">Application</NavLink>
                            <div className="nav-link disabled">|</div>
                            <NavDropdown title="Additional Resources">
                                <NavDropdown.Item href="https://hf.org/health-first-health-plans/providers/provider-directories/provider-directory-individual-and-family" target="_blank" rel="noreferrer">HFHP Provider Directory</NavDropdown.Item>
                                <NavDropdown.Item href="https://hf.org/health-first-health-plans/brokers" target="_blank" rel="noreferrer">Broker Resources</NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                        <Nav className="ms-auto"></Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    )
};

export default ComHeader;